import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { styled } from "@mui/material";
import clsx from "clsx";
import { paths } from "utils/paths";

const RecipientsRow = styled("div")(({ theme }) => ({
  paddingLeft: "0.5rem",
  marginBottom: "0.5rem",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  "& .count-label": {
    fontSize: "14px",
    color: "#4D4D4D",
  },
  "& .count": {
    marginLeft: "0.5rem",
    fontWeight: 700,
  },
  "& .available-sms": {
    color: "#9F9C9C",
    "&.error": {
      color: "#D34931",
    },
  },
  "& .learn-more": {
    marginLeft: "0.5rem",
    color: "#5A5555",
  },
}));

const ErrorBox = styled("div")({
  padding: "0.5rem 0.75rem",
  backgroundColor: "#F0C2BA66",
  borderRadius: "0.5rem",
  marginBottom: "0.5rem",
  color: "#D34931",
});

const MessageRecipients = ({ isEmail, recipientsNames = [], balance }) => {
  const { t } = useTranslation();

  const availableSms = useMemo(
    () => balance?.smsBalance || 0,
    [balance?.smsBalance]
  );

  const hasNotEnough = useMemo(() => {
    return recipientsNames.length > availableSms || availableSms === 0;
  }, [recipientsNames, availableSms]);

  return (
    <>
      <RecipientsRow>
        <div>
          <span className="count-label"> {t("NewMessageModal.To")}</span>
          <span className="count">{recipientsNames.length}</span>
        </div>
        {!isEmail && (
          <div>
            <span className={clsx("available-sms", { error: hasNotEnough })}>
              {t(`NewMessageModal.Sms.AvailableSms`, {
                count: availableSms,
              })}
            </span>
            <NavLink to={paths.settings.profile} className="learn-more">
              {t(`NewMessageModal.Sms.LearnMore`)}
            </NavLink>
          </div>
        )}
      </RecipientsRow>
      {!isEmail && hasNotEnough && (
        <ErrorBox>{t(`NewMessageModal.Sms.NotEnough`)}</ErrorBox>
      )}
    </>
  );
};

export default MessageRecipients;
